/**
 * This code imports the createSlice function from the '@reduxjs/toolkit' library.
 * It also initializes the initial state of the loaderSlice with a loading property set to true.
 * The createSlice function is used to create a slice of the Redux store with the name 'loader'.
 * The slice has a single reducer function called 'setLoading' which updates
 * the loading property of the state with the payload value passed in the action.
 * The 'setLoading' reducer is exported as an action creator along with
 * the entire loaderSlice reducer.
 */

import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: true
}

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    }
  }
})

export const { setLoading } = loaderSlice.actions

export default loaderSlice.reducer
